import compact from 'lodash/compact';

const getNodeInfo = (results) => {
  const { selectedCount = 0, leafsCount = 0 } =
    results?.reduce(
      (acc, result) => {
        acc.selectedCount += result.selectedCount || 0;
        acc.leafsCount += result.leafsCount || 0;
        return acc;
      },
      {
        selectedCount: 0,
        leafsCount: 0,
      },
    ) || {};

  return {
    leafsCount,
    selectedCount,
  };
};

const setNodeState = (node, nodeInfo = {}, { showOnlySelected, showOnlyNonEmpty }) => {
  // @ts-expect-error
  if (nodeInfo.selectedCount || nodeInfo.leafsCount) {
    node.visible = true;
    // @ts-expect-error
    node.leafsCount = nodeInfo.leafsCount;
    // @ts-expect-error
    node.selectedCount = nodeInfo.selectedCount;
    return;
  }

  node.leafsCount = 0;
  node.selectedCount = 0;
  node.visible = showOnlySelected ? false : showOnlyNonEmpty ? false : true;
};

export const initMenu = (root, selectedOptions, props) => {
  const { isOption, getOptionId, getMenuId, showOnlySelected } = props;

  if (!root) {
    return root;
  }

  const traverse = (node, parentPath = '') => {
    if (!node) {
      return 0;
    }

    node.parentPath = parentPath;

    if (isOption(node)) {
      let isSelected = false;
      selectedOptions.forEach((selectedOption) => {
        if (getOptionId(selectedOption) === getOptionId(node)) {
          selectedOption.parentPath = parentPath;
          isSelected = true;
          return false;
        }
      });
      node.visible = showOnlySelected ? isSelected : true;
      return {
        leafsCount: 1,
        selectedCount: isSelected ? 1 : 0,
      };
    }

    const results = node.children?.map((child) => {
      const nextParentPath = compact([parentPath, getMenuId(node)]).join('|');
      return traverse(child, nextParentPath);
    });

    const nodeInfo = getNodeInfo(results);

    setNodeState(node, nodeInfo, props);

    return nodeInfo;
  };

  traverse(root);

  return { ...root };
};

export const updateMenu = (root, selectedOptions, props) => {
  const { showOnlySelected, showOnlyNonEmpty, isOption, getOptionId } = props;

  if (!root) {
    return root;
  }

  const traverse = (node) => {
    if (!node) {
      return 0;
    }

    if (isOption(node)) {
      const selected = selectedOptions.find((selectedOption) => getOptionId(selectedOption) === getOptionId(node));
      node.visible = showOnlySelected ? !!selected : true;
      return {
        leafsCount: 1,
        selectedCount: !!selected ? 1 : 0,
      };
    }

    const results = node.children?.map(traverse);

    const nodeInfo = getNodeInfo(results);

    if (nodeInfo.selectedCount > 0) {
      node.visible = true;
      node.leafsCount = nodeInfo.leafsCount;
      node.selectedCount = nodeInfo.selectedCount;
      return nodeInfo;
    }

    if (nodeInfo.leafsCount > 0) {
      node.visible = !showOnlySelected;
      node.leafsCount = nodeInfo.leafsCount;
      node.selectedCount = nodeInfo.selectedCount;
      return nodeInfo;
    }

    node.leafsCount = 0;
    node.selectedCount = 0;
    node.visible = showOnlySelected ? false : showOnlyNonEmpty ? false : true;
    return nodeInfo;
  };

  traverse(root);

  return { ...root };
};

export const updateTreeExpandedState = (root, expanded, isSkipped) => {
  const traverse = (node) => {
    const newChildren = node.children?.map(traverse);

    const skipNode = typeof isSkipped === 'function' ? isSkipped(root, node) : false;

    const nextExpanded = skipNode ? node.expanded : expanded;

    return {
      ...node,
      children: newChildren,
      expanded: nextExpanded,
    };
  };

  return traverse(root);
};

export const updateNodeExpandedState = (root, targetNode, getNodeId, expanded) => {
  const targetNodeId = getNodeId(targetNode);

  const traverse = (node) => {
    if (!node) {
      return node;
    }

    if (getNodeId(node) === targetNodeId) {
      return {
        ...node,
        expanded,
      };
    }

    const newChildren = node.children?.map(traverse);

    return {
      ...node,
      children: newChildren,
    };
  };

  return traverse(root);
};
